import http from "../http-common";
import authHeader from "./authHeader";
import {CANDIDATE_API, REMARK_API} from "../api";

const getAllRemark = () => {
  return http.get(`${REMARK_API}`);
};
const getAllOptions = () => {
  return http.get(`${CANDIDATE_API}/options/1`);
};
const createOption = (data) => {
  return http.post(`${CANDIDATE_API}/options/1`, data, { headers: authHeader()});
};

const searchCandidate = (regNumber) => {
  return http.get(`${CANDIDATE_API}/${regNumber}`, { headers: authHeader()});
};

const shortList = (data) => {
  return http.post(`${CANDIDATE_API}/filter/get`, data, { headers: authHeader()});
};

const updateProperties = (id,regNumber, data) => {
  return http.put(`${CANDIDATE_API}/properties/${id}?regNumber=${regNumber}`, data, { headers: authHeader() });
};

const uploadNewFile = (data) => {
  return http.post(`${CANDIDATE_API}/newfiles/1`, data, { headers: authHeader() });
};

const getNewFiles = (nic, ent) => {
  return http.get(`${CANDIDATE_API}/newfiles/1`, {
    params: { nic, ent }, // Use an object to define query parameters
    headers: authHeader(),
  });
};


const CandidateService = {
  getAllRemark,
  getAllOptions,
  uploadNewFile,
  getNewFiles,
  createOption,
  updateProperties,
  searchCandidate,
  shortList
};

export default CandidateService;
